import { ReactNode } from 'react';

import { ReactComponent as IconAlertCircle } from '@/assets/icon-alert-circle.svg';
import { TemplateType } from '@/components/SearchTablePage/types/tplTypes';
import { QueryObjectType } from '@/components/SearchTablePage/utils/commonInterface';
import useEscrowAccount from '@/hooks/useEscrowAccount';
import { useI18nContext } from '@/i18n/I18n';
import { escrowInstitutionCodes } from '@/utils/pageConfig/openApi';

export const useFormItem = () => {
  const [$t] = useI18nContext();
  const { authName } = useEscrowAccount();

  const getFormItems: (
    renderSuffix: (id: 'apiKey' | 'secret') => ReactNode,
    apiType?: string,
  ) => QueryObjectType[] = (renderSuffix, apiType) => {
    console.log('apiType', apiType);
    const queryCol: QueryObjectType[] = [
      {
        id: 'note',
        tpl: TemplateType.Input,
        disabled: true,
        label: $t('addSecretKey.p7'),
      },
      {
        id: 'apiKey',
        tpl: TemplateType.Input,
        disabled: true,
        label: $t('APISecretKey'),
        componentProps: {
          suffix: renderSuffix('apiKey'),
        },
        // 如果当前为托管商首次创建API，提示用户API仅提供给托管商使用
        formItemProps: escrowInstitutionCodes.includes(apiType || '')
          ? {
              help: (
                <div className="api-secret-key-copper-tips">
                  <IconAlertCircle fill="currentColor" />
                  {$t('apiInfoModalInstitutionTip').replace(
                    '{{name}}',
                    $t(authName),
                  )}
                </div>
              ),
            }
          : {},
      },
      {
        id: 'secret',
        tpl: TemplateType.Input,
        disabled: true,
        label: $t('Secret Key'),
        componentProps: {
          suffix: renderSuffix('secret'),
        },
      },
      {
        id: 'permissions',
        tpl: TemplateType.TextArea,
        label: $t('Permission'),
        componentProps: { disabled: true },
      },
    ];
    console.log('apiType 2', queryCol);
    return queryCol;
  };
  return { getFormItems };
};
